export default "__VITE_ASSET__BTImAAdN__"